import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
const Price = () => {
  return (
    <div>
      <Helmet>
        <title>Daftar Harga Aplikasi toko penjuan kasir vpos web app</title>
        <meta
          content="Daftar Harga Aplikasi toko penjuan kasir vpos web app"
          name="twitter:title"
        />
        <meta
          content="Daftar Harga Aplikasi toko penjuan kasir vpos web app"
          name="facebook:title"
        />
        <meta
          content="Daftar Harga Aplikasi toko penjuan kasir vpos web app"
          property="og:title"
        />
        <meta
          content="Daftar Harga Aplikasi toko penjuan kasir vpos web app"
          property="og:site_name"
        />
        <meta
          content="Daftar Harga Mesin kasir online vpos mudah digunakan dan dilengkapi dengan laporan stok, pendapatan omset,plus website modern terbaru all in one pada vpos web app."
          property="og:description"
        />
        <meta
          name="description"
          content="Daftar Harga Mesin kasir online vpos mudah digunakan dan dilengkapi dengan laporan stok, pendapatan omset,plus website modern terbaru all in one pada vpos web app."
        />
        <meta
          content="Daftar Harga Mesin kasir online vpos mudah digunakan dan dilengkapi dengan laporan stok, pendapatan omset,plus website modern terbaru all in one pada vpos web app."
          property="facebook:description"
        />
        <meta
          content="Daftar Harga Mesin kasir online vpos mudah digunakan dan dilengkapi dengan laporan stok, pendapatan omset,plus website modern terbaru all in one pada vpos web app."
          name="twitter:description"
        />
        <meta
          content="https://1.bp.blogspot.com/-oolLYoq-j5Q/X93ym6YAD8I/AAAAAAAALus/NZ7SFbMNI543KZaqFx129dX0ST4MBQAQACLcBGAsYHQ/w1200-h630-p-k-no-nu/TOUCHSCREEN3.png"
          property="og:image"
        />
        <meta content="https://axcora.com/getaxcoracms" property="og:author" />

        <meta content="website" property="og:type" />
        <meta
          content="https://www.facebook.com/mesinkasircomplete"
          property="facebook:author"
        />
        <meta
          content="https://res.cloudinary.com/hockeycorp/image/upload/v1568369085/touchscreen_yonrpa.jpg"
          name="facebook:image"
        />
        <meta content="summary_large_image" name="twitter:card" />
        <meta
          content="https://twitter.com/hockeycomp"
          property="twitter:author"
        />
        <meta content="@hockeycomp" name="twitter:site" />
        <meta
          content="https://res.cloudinary.com/hockeycorp/image/upload/v1568369085/touchscreen_yonrpa.jpg"
          name="twitter:image"
        />
        <meta content="index, follow" name="robots" />
      </Helmet>
      <div className="animate__animated animate__bounceInDown row">
        <div className="col-12 col-md-4 p-3">
          <h3 className="text-primary">Basic</h3>
          <hr />+ Vpos Apps
          <hr />+ Free domain .my.id
          <hr />+ Cloud Hosting
          <hr />+ 1 Page Website
          <hr />+ 500MB Web Space
          <hr />+ Layanan Bantuan
          <hr />+ Layanan Konsultasi
          <hr />
          <p className="text-danger">Rp.568.400/Tahun</p>
          <hr />
          <a
            href="https://wa.me/62895339403223?text=Axcoraapps%20saya%20mau%20order%20Webapp%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaketwebapp%20%3AVposappbasic%0APrice%20%3ARp.568.400/tahun%0APembayaran%20via%20%3A%0ABCA%208290363021%20Rica%20Anggraini%0A%0Atolong%20diproses%20pesanan%20saya"
            className="btn btn-primary"
          >
            Order Now
          </a>
        </div>
        <div className="col-12 col-md-4 p-3">
          <h3 className="text-primary">Premium</h3>
          <hr />+ Vpos Apps
          <hr />+ Free domain .com
          <hr />+ Cloud Hosting
          <hr />+ Get Axcora webapp
          <hr />+ 500MB Web Space
          <hr />+ APK Android Backend
          <hr />+ APK Android Frontend
          <hr />+ Layanan Bantuan
          <hr />+ Layanan Konsultasi
          <hr />
          <p className="text-danger">Rp.3.264.800/Tahun</p>
          <hr />
          <a
            href="https://wa.me/62895339403223?text=Axcorasapps%20saya%20mau%20order%20Webapp%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaketwebapp%20%3AVposapppremium%0APrice%20%3ARp.3.264.800/tahun%0APembayaran%20via%20%3A%0ABCA%208290363021%20Rica%20Anggraini%0A%0Atolong%20diproses%20pesanan%20saya"
            className="btn btn-primary"
          >
            Order Now
          </a>
        </div>
        <div className="col-12 col-md-4 p-3">
          <h3 className="text-primary">Standard</h3>
          <hr />+ Vpos Apps
          <hr />+ Free domain .com
          <hr />+ Cloud Hosting
          <hr />+ Get Axcora webapp
          <hr />+ 500MB Web Space
          <hr />+ APK Android Backend
          <hr />+ Layanan Bantuan
          <hr />+ Layanan Konsultasi
          <hr />
          <p className="text-danger">Rp.1.561.200/Tahun</p>
          <hr />
          <a
            href="https://wa.me/62895339403223?text=Axcoraapps%20saya%20mau%20order%20Webapp%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaketwebapp%20%3AVposappstandard%0APrice%20%3ARp.1.561.200/tahun%0APembayaran%20via%20%3A%0ABCA%208290363021%20Rica%20Anggraini%0A%0Atolong%20diproses%20pesanan%20saya"
            className="btn btn-primary"
          >
            Order Now
          </a>
        </div>
        <div className="text-center">
          <Link to="/demo" className="btn btn-outline-primary rounded">
            Cek Demo Aplikasi
          </Link>
        </div>
      </div>
    </div>
  );
};
export default Price;
